import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { InitAction, ProjectAction } from "../actions";
import * as projectApi from "../api/project";
import { toastr } from "react-redux-toastr";
import PROJECT_STATE from "../constants/projectState";
import { NEAR_ENDING_PREMIUM, PREMIUM } from "../constants/premiumState";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherProject() {
  yield takeLatest(types.PROJECT_LIST_REQUEST, worker);
  yield takeLatest(types.PROJECT_STORE_REQUEST, store);
  yield takeLatest(types.PROJECT_DELETE_REQUEST, _delete);
  yield takeLatest(types.PROJECT_UPDATE_REQUEST, edit);
  yield takeLatest(types.PROJECT_ACCEPT_REQUEST, accept);
  yield takeLatest(types.PROJECT_REJECT_REQUEST, reject);
  yield takeLatest(types.PROJECT_ARCHIVE_REQUEST, archive);
  yield takeLatest(types.PROJECT_USERS_LIST_REQUEST, getUserList);
}

function fetchInit() {
  return projectApi.init();
}

function* worker() {
  try {
    const response = yield call(fetchInit);
    yield put(ProjectAction.getSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectAction.getFailure(error));
  }
}

function fetchStore(data) {
  return projectApi.store(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    if (
      response.data.data &&
      response.data.data.project &&
      response.data.data.project.id &&
      parseInt(response.data.data.state) === PROJECT_STATE.ACTIVE
    ) {
      response.data.message.forEach(message => {
        toastr.success(" ", message.toString());
      });
      localStorage.setItem("project_id", response.data.data.project.id);
      localStorage.setItem(
        "project_info",
        JSON.stringify({
          ...response.data.data.project,
          is_owner: response.data.data.is_owner
        })
      );
      yield put(ProjectAction.storeSuccess(response.data.data));
      if (action.isReload) {
        window.location.replace("/");
        yield put({ type: types.INIT_REQUEST });
      }
    } else if (
      !action.isReload &&
      parseInt(response.data.data.state) === PROJECT_STATE.INACTIVE
    ) {
      if (!localStorage.getItem("project_id")) {
        sessionStorage.setItem("project_state", response.data.data.state);
        localStorage.setItem("project_id", response.data.data.project.id);
      }
      yield put(ProjectAction.storeSuccess(response.data.data));
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectAction.getFailure(error));
  }
}

function deleteProject(id) {
  return projectApi._delete(id);
}

function* _delete(action) {
  try {
    const response = yield call(deleteProject, action.id);
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (
      parseInt(action.id) ===
      parseInt(JSON.parse(localStorage.getItem("project_id")))
    ) {
      localStorage.removeItem("project_id");
      window.location.reload();
    } else {
      yield put(ProjectAction.deleteSuccess(action.id));
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ProjectAction.deleteFailure());
  }
}

function editProject(data, id) {
  return projectApi.edit(data, id);
}

function* edit(action) {
  try {
    const response = yield call(editProject, action.data, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (
      parseInt(response.data.data.project.id) ===
      parseInt(localStorage.getItem("project_id"))
    ) {
      localStorage.setItem(
          "project_info",
          JSON.stringify({
            ...response.data.data.project,
            is_owner: response.data.data.is_owner
          })
      );
      window.location.reload();
    }
    yield put(ProjectAction.editSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ProjectAction.editFailure(error));
  }
}
function acceptProject(id) {
  return projectApi.accept(id);
}
function* accept(action) {
  try {
    const response = yield call(acceptProject, action.id);
    const project = response.data.project;
    if (
      project.project.premium_state === PREMIUM ||
      project.project.premium_state === NEAR_ENDING_PREMIUM
    ) {
      localStorage.setItem(
        "project_info",
        JSON.stringify({ ...project.project, is_owner: project.is_owner })
      );
      localStorage.setItem("project_id", response.data.project.project.id);
    }
    yield put(ProjectAction.acceptSuccess(response.data.project));
    window.location.reload();
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ProjectAction.acceptFailure());
  }
}
function rejectProject(id) {
  return projectApi.reject(id);
}
function* reject(action) {
  try {
    yield call(rejectProject, action.id);
    yield put(ProjectAction.rejectSuccess(action.id));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ProjectAction.rejectFailure());
  }
}

function archiveProject(id, data) {
  return projectApi.archive(id, data);
}

function* archive(action) {
  try {
    const response = yield call(archiveProject, action.id, action.data);
    // yield put(InitAction.getSuccess({premium: response.data.premium}));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (action.id == localStorage.getItem("project_id")) {
      localStorage.removeItem("project_id");
      window.location.reload();
    }
    yield put(ProjectAction.archiveSuccess(action.id, action.data));
  } catch (error) {
    yield put(ProjectAction.archiveFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function* getUserList() {
  try {
    const response = yield call(fetchUserList);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data.data;
    yield put(ProjectAction.getUsersListSuccess(data));
  } catch (error) {
    yield put(ProjectAction.getUsersListFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchUserList() {
  return projectApi.getUsersList();
}
